function MoviesPlaceholder() {
  return (
    <div className="d-flex flex-wrap justify-content-around">
      <div
        className="card mb-4"
        aria-hidden="true"
        style={{
          width: "18rem",
          height: "30rem",
          minWidth: "16rem",
          boxShadow: "0px 10px 33px -7px rgba(0,0,0,0.75)",
        }}
      >
        <div className="card-body placeholder-glow">
          <div style={{ height: "25rem" }} className="placeholder col-12"></div>
        </div>
        <div className="card-footer" style={{ height: "3rem" }}>
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        </div>
      </div>
      <div
        className="card mb-4"
        aria-hidden="true"
        style={{
          width: "18rem",
          height: "30rem",
          minWidth: "16rem",
          boxShadow: "0px 10px 33px -7px rgba(0,0,0,0.75)",
        }}
      >
        <div className="card-body placeholder-glow">
          <div style={{ height: "25rem" }} className="placeholder col-12"></div>
        </div>
        <div className="card-footer" style={{ height: "3rem" }}>
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        </div>
      </div>
      <div
        className="card mb-4"
        aria-hidden="true"
        style={{
          width: "18rem",
          height: "30rem",
          minWidth: "16rem",
          boxShadow: "0px 10px 33px -7px rgba(0,0,0,0.75)",
        }}
      >
        <div className="card-body placeholder-glow">
          <div style={{ height: "25rem" }} className="placeholder col-12"></div>
        </div>
        <div className="card-footer" style={{ height: "3rem" }}>
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        </div>
      </div>
      <div
        className="card mb-4"
        aria-hidden="true"
        style={{
          width: "18rem",
          height: "30rem",
          minWidth: "16rem",
          boxShadow: "0px 10px 33px -7px rgba(0,0,0,0.75)",
        }}
      >
        <div className="card-body placeholder-glow">
          <div style={{ height: "25rem" }} className="placeholder col-12"></div>
        </div>
        <div className="card-footer" style={{ height: "3rem" }}>
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default MoviesPlaceholder;
